import issuerList from 'norbr-shared-lib/constants/issuers/list';

const IssuerBranchTitle = ({ branch }) => branch.condition.reduce((acc, issuer) => `${acc}${issuerList?.find(issuerElem => issuerElem.id === issuer)?.label ?? issuer}, `, '').slice(0, -2) ?? '';

export default IssuerBranchTitle;